<template lang="pug">
.metaContainer(v-loading="loading", element-loading-text="数据更新中...")
  .title 自定义页面
  .oper
    el-button(type="primary", plain, size="small", @click="addFormDialog") 新建自定义页面
    el-button(size="small", :disabled="multipleSelection.length === 0", @click="metaDelete") 删 除
  .list
    el-table(
      border,
      round,
      resizable,
      size="medium",
      show-overflow,
      keep-source,
      ref="xTable",
      :data="tableData",
      @selection-change="selectChangeEvent",
      :edit-config="{ trigger: 'manual', mode: 'row' }"
    )
      el-table-column(type="selection", width="60", align="center")
      el-table-column(type="index", width="60", align="center", label="序号")
      el-table-column(prop="pageName", align="center", label="自定义页面名称")
      el-table-column(prop="pageCode", align="center", label="自定义页面编号")
      el-table-column(prop="remark", align="center", label="自定义页面页描述")
      el-table-column(field="", align="center", label="操作", v-slot="{ row }")
        el-button(size="mini", status="primary", @click="showDetailRow(row)") 编 辑
  addCustomDialog(ref="dataDialog", @initTree="initTree", title="编辑")
</template>

<script>
import addCustomDialog from "./dialog/addCustomDialog.vue";
import { dyn_custom_page_batchDelete, dyn_custom_page_list } from "@/CommonDP/service/metadata-custom-page-service";
export default {
  components: { addCustomDialog },
  data() {
    return {
      dataDialog: "",
      tableData: [],
      formData: {},
      loading: false,
      multipleSelection: [],
      metaList: []
    };
  },
  methods: {
    queryList(data) {
      this.formData = data;
      this.dynTableList();
    },
    // 获取列表
    async dynTableList() {
      const { data } = await dyn_custom_page_list(this.formData.groupId);
      this.tableData = data || [];
    },

    selectChangeEvent(records) {
      this.multipleSelection = records;
    },

    initTree() {
      this.$emit("initTree");
      this.dynTableList();
    },
    async metaDelete() {
      await this.$confirm(`确认删除选中的数据吗?`, "提示", { type: "warning" });
      this.loading = true;
      const batchIdList = this.multipleSelection.map((e) => e.pageId);
      await dyn_custom_page_batchDelete(batchIdList);
      this.initTree();
      this.$success("操作成功");
      this.loading = false;
    },
    addFormDialog() {
      this.$emit("openTypeDialog", this.formData, "addCustom");
    },
    // 业务模型详情
    async showDetailRow(row) {
      this.$refs.dataDialog.init(row);
    },
    update() {
      this.dynTableList();
    }
  }
};
</script>

<style lang="scss" scoped>
.metaContainer {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .title {
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    padding: 10px 0;
    line-height: 25px;
    color: var(--key-color);
    font-weight: 600;
    font-size: 16px;
  }

  .oper {
    padding: var(--middle-space) 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}

.headStyle {
  background-color: #dddee6 !important;
  color: var(--key-color);
  height: 44px;
}

/deep/.el-table--render-default.el-editable .el-body--column,
.el-table--render-default.el-editable .el-body--column.col--actived {
  padding: 11px 0;
}
</style>

